// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PrimaryContact_wrapper__1kqAz","info":"PrimaryContact_info__28Ggk","separate":"PrimaryContact_separate__2FLXE","contacts":"PrimaryContact_contacts__FeVQJ"};